import React, { Component } from 'react';
import {Spacer, Button, InputInline} from 'app/components/Basics/'
import { Icons } from '@ecosystem/ui-lib/core/components/Icon';
import './GlobalControlLineComponent.scss';
import { ReactComponent as SaveIcon } from 'app/assets/icons/Save.svg';
import { ReactComponent as DuplicateIcon } from 'app/assets/icons/Duplicate-Plus.svg';
import {HoneypotSetFormContext} from '../../HoneypotSetContext'
import ValidateHoneypotSet from '../../HoneypotSetValidation'
 
class GlobalControlLine extends Component {

    constructor(props){
        super(props);

        this.state = {            
        }        
    }

    componentWillReceiveProps(nextProps) {        
        if (nextProps && nextProps.errors) {            
            var error = nextProps.errors.find(e => e.field === "name")
            if (error) {
                this.setState({errorHoneypotSetName: error.errorMessage})
            }
        }
    }

    getNewHoneypotSetName(isEditorOpen, newHoneypotSetName) {
        if (!isEditorOpen) {
            var selectedHoneypotSet = this.context.selectedHoneypotSet;
            selectedHoneypotSet.name = newHoneypotSetName;
            this.context.updateSelectedHoneypotSet(selectedHoneypotSet);
        }
    }
	
	isSaveDisabled() {
		let result = false;
		var errors = ValidateHoneypotSet(this.context.selectedHoneypotSet);		
		if (errors.length > 0) {
			result = true;
		}		
		if (!this.props.didSelectedHoneypotSetChange()) {
			result = true;
		}
		return result;
	}

	isNewHoneypotSet() {
		return this.context.selectedHoneypotSet.id === null;
	}	

	userCannotChangeData() {
		return !this.props.canChangeData;
	}

    render() {
        return (
            <div className="GlobalControlLineComponent form-row">
                <InputInline disabled={this.userCannotChangeData()} enableOnBlur className="name-field" error={this.state.errorHoneypotSetName} value={this.context.selectedHoneypotSet.name} onModeChange={this.getNewHoneypotSetName.bind(this)} />
                <div className="contol-buttons">                    
                    <Button disabled={this.userCannotChangeData() || this.isSaveDisabled()} title="Save all changes in the survey" icon={<SaveIcon/>} onClick={this.props.handleSubmitAction}>Save</Button>                    
                    <Button title="Close current editor and discard all unsaved changes" onClick={this.props.closeEditorButtonOnClick} simple icon={Icons.Close}>Close</Button>
                    <Spacer width={20}/>                   
                    <Button disabled={this.userCannotChangeData() || this.isNewHoneypotSet()} title="Delete the survey is irreversible" small secondary icon={Icons.Delete} onClick={this.props.deleteHoneypotSet}>Delete</Button>
                    <Button disabled={this.userCannotChangeData() || this.isNewHoneypotSet()} title="Create a new survey as duplicate from this survey" small secondary icon={<DuplicateIcon/>} onClick={this.props.duplicateHoneypotSet}>Duplicate</Button>					
                </div>
                
            </div>  
        );
    }
}
GlobalControlLine.contextType = HoneypotSetFormContext;
export default GlobalControlLine;